import { ProductionClass } from '../production.class';
import * as Constants from '../../globals/constants';
import { ResourceService } from '../../services/resource.service';
import { PopulationService } from '../../services/population.service';
import { TechnologyService } from '../../services/technology.service';

/**
 * @internal
 * The isolateExtension allows the user to isolate current selection in the viewer.
 */
export class GoldSmith extends ProductionClass {

  /**
   * @ignore
   */
  constructor(resourceHandler: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    super(resourceHandler, populationService, technologyService);
    this.initBuilding('Goldsmith', 'goldsmith', Constants.SETTINGS.BUILDING_SETTINGS.GOLDSMITH);
  }

  public setResearchBonus() {
    const additiveMultiplier = [];
    const multiplicativeMultiplier = [];

    if (this.technologyService.state.tomorrow) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.deep_space_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.dimensional_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }

    // ----

    if (this.technologyService.state.maritime_trading) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.trade_post) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.factory) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.explosives) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.mass_production) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.capitalism) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.automation) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.recycle) {
      multiplicativeMultiplier.push(.1);
    }

    if (this.technologyService.state.matter_generation) {
      multiplicativeMultiplier.push(.15);
    }

    const amResult = additiveMultiplier.reduce((a, b) => a + b, 1);
    const mmResult = multiplicativeMultiplier.reduce((a, b) => a * (1 + b), 1);

    this.reseachMultiplier = 1 * amResult * mmResult;
  }

  public unlock() {
    return this.technologyService.state.gold_smith;
  }
  public getBuildingImage() {
    return 'https://comps.canstockphoto.com/goldsmith-workshop-in-the-sixteenth-drawing_csp31369099.jpg'
    // if (this.technologyService.state.brick_house) {
    //   return 'https://i.pinimg.com/564x/75/b0/c0/75b0c082798d763add59f09fb17fddfa.jpg';
    // } else  if (this.technologyService.state.brick_house) {
    //     return 'https://i.pinimg.com/564x/75/b0/c0/75b0c082798d763add59f09fb17fddfa.jpg';
    //   } {
    //   return 'https://image.shutterstock.com/image-vector/rural-landscape-field-wheat-hand-260nw-1328421050.jpg'
    // }
  }

}
